module.exports = __webpack_public_path__ + "img/gear_blue.899f400f.svg";